import { AxiosInstance } from 'axios';

import { getKeycloakToken } from '@tsl-frontend/tsl-keycloak-auth';

export const addKeycloakInterceptor = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.request.use(
        async (config) => {
            const token = await getKeycloakToken();

            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        },
        (error) => Promise.reject(error),
    );
};
